import { render, staticRenderFns } from "./MailBoxAgencyClient.vue?vue&type=template&id=1e08059e&scoped=true"
import script from "./MailBoxAgencyClient.vue?vue&type=script&lang=js"
export * from "./MailBoxAgencyClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e08059e",
  null
  
)

export default component.exports